import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";

import App from "./containers/App/App";
import configureStore from "./redux/configureStore";
import registerServiceWorker from "./registerServiceWorker";

// Use browser history in this application
const browserHistory = createBrowserHistory();

// Create store with reducers and middleware
const store = configureStore(browserHistory);

ReactDOM.render(
  <App history={browserHistory} store={store} />,
  document.getElementById("root")
);

// In production, we register a service worker to serve assets from local cache.
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js